import React from "react"
import PersonnelDocuments from "./_PersonnelDocuments"
import PersonnelDocumentsEmbauche from "./_PersonnelDocumentsEmbauche"
import DocumentCategory from "./_DocumentCategory"
import useUser from "../../../../hooks/useUser"

// Onglet "Documents" de la fiche staff. Organisé en grandes catégories de documents
// repliables et défilables : documents administratifs (collaborateur + fournisseur)
// et documents d'embauche (dossier de l'entité). Les déclarations d'activité, arrêts maladie
// et congés sont désormais dans l'onglet "Activité".
const Documents = () => {
     const { canManageStaffAdministrativeDocuments, canViewStaff } = useUser()

     return (
          <div className={"d-flex flex-column gap-6"}>
               {/* Documents administratifs — masqués pour le manager métier (accès complet ou restreint uniquement) */}
               {canManageStaffAdministrativeDocuments() && (
                    <DocumentCategory title={"Documents administratifs"} subtitle={"Pièces du collaborateur et du fournisseur"} icon={"fa-folder-open"} color={"success"} maxHeightPx={760}>
                         <PersonnelDocuments />
                    </DocumentCategory>
               )}

               {/* Documents d'embauche — dossier de l'entité, envoi à l'email personnel (consultation staff) */}
               {canViewStaff() && (
                    <DocumentCategory title={"Documents d'embauche"} subtitle={"Documents du dossier de l'entité à envoyer au collaborateur"} icon={"fa-paper-plane"} color={"info"} maxHeightPx={760}>
                         <PersonnelDocumentsEmbauche />
                    </DocumentCategory>
               )}
          </div>
     )
}

export default Documents
